module.exports = __webpack_public_path__ + "img/ewm_wx.38b8969e.png";